import {ROUTE_NAMES} from "@/shared/constants/routeNames.ts";

export interface MenuItem {
    id: number
    label: string
    icon: string
    route: string
    children: MenuItem[] | null
}

export interface MenuGroup {
    id: number,
    icon: string
    label: string
    route: string
    includes: string[]
    children: MenuItem[]
}

export interface StandaloneModuleConfig {
    icon: string
    route: string
}

export type MenuHierarchy = Record<string, MenuGroup>
export type StandaloneModules = Record<string, StandaloneModuleConfig>

export const MENU_HIERARCHY: MenuHierarchy = {
    ADMINISTRACION: {
        id: 1,
        icon: 'fa-solid fa-users-cog',
        label: 'Administración',
        route: ROUTE_NAMES.ADMINISTRATION.USERS.name,
        includes: ['USUARIOS', 'MODULOS'],
        children: []
    },
    MAESTROS: {
        id: 2,
        icon: 'fa-solid fa-boxes',
        label: 'Maestros',
        route: ROUTE_NAMES.MASTERS.WAREHOUSE.name,
        includes: ['BODEGAS', 'UNIDAD', 'RUBROS', 'ARTICULOS', 'MOTIVOS', 'FORMULAS'],
        children: []
    },
    PROCESOS: {
        id: 3,
        icon: 'fa-solid fa-route',
        label: 'Procesos',
        route: ROUTE_NAMES.PROCESS.MATERIAPRIMA.name,
        includes: ['MEZCLAS','MATERIAP', 'MATERIALE', 'SACHETADO', 'EMPAQUETADO', 'MEZCLASL', 'PRODUCTOT', 'CALIDAD'],
        children: []
    },
    REPORTES: {
      id: 4,
      icon: 'fa-solid fa-route',
      label: 'Reportes',
      route: ROUTE_NAMES.REPORTS.name,
      includes: ['reportes'],
      children: []
    }
}

export const STANDALONE_MODULES: StandaloneModules = {
    USUARIOS: {
        icon: 'fa-solid fa-users',
        route: ROUTE_NAMES.ADMINISTRATION.USERS.name,
    },
    MODULOS: {
        icon: 'fa-solid fa-kaaba',
        route: ROUTE_NAMES.ADMINISTRATION.MODULES.name,
    },
    BODEGAS: {
        icon: 'fa-solid fa-warehouse',
        route: ROUTE_NAMES.MASTERS.WAREHOUSE.name,
    },
    UNIDAD: {
        icon: 'fa-solid fa-dice-one',
        route: ROUTE_NAMES.MASTERS.UNITS.name
    },
    RUBROS: {
        icon: 'fa-solid fa-book',
        route: ROUTE_NAMES.MASTERS.RUBRO.name
    },
    ARTICULOS: {
        icon: 'fa-solid fa-arrow-trend-up',
        route: ROUTE_NAMES.MASTERS.ARTICLES.name
    },
    MOTIVOS: {
        icon: 'fa-solid fa-comment',
        route: ROUTE_NAMES.MASTERS.MOTIVOS.name
    },
    MATERIAP: {
        icon: 'fa-solid fa-truck-moving',
        route: ROUTE_NAMES.PROCESS.MATERIAPRIMA.name
    },
    MATERIALE: {
        icon: 'fa-solid fa-box',
        route: ROUTE_NAMES.PROCESS.MATERIALEMPAQUE.name
    },
    MEZCLAS: {
        icon: 'fa-solid fa-truck-moving',
        route: ROUTE_NAMES.PROCESS.MIXTURE.name
    },
    MEZCLASL: {
        icon: 'fa-solid fa-truck-moving',
        route: ROUTE_NAMES.PROCESS.LIQUIDS.name
    },
    FORMULAS: {
        icon: 'fa-solid fa-vial',
        route: ROUTE_NAMES.MASTERS.FORMULAS.name
    },
    SACHETADO: {
      icon: 'fa-solid fa-truck-moving',
      route: ROUTE_NAMES.PROCESS.PACKAGING.name
    },
    EMPAQUETADO: {
      icon: 'fa-solid fa-truck-moving',
      route: ROUTE_NAMES.PROCESS.PRODUCT_FLOW.name
    },
    PRODUCTOT: {
        icon: 'fa-solid fa-truck-moving',
        route: ROUTE_NAMES.PROCESS.FINAL_PRODUCT.name
    },
    CALIDAD: {
        icon: 'fa-solid fa-truck-moving',
        route: ROUTE_NAMES.PROCESS.QUALITY.name
    },
    REPORTES: {
        icon: 'fa-solid fa-chart-area',
        route: ROUTE_NAMES.REPORTS.name
    }
}